Apex.chart = {
    locales: [{
        "name": "ru",
        "options": {
            "months": ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"],
            "shortMonths": ["Янв", "Фев", "Мар", "Апр", "Май", "Июн", "Июл", "Авг", "Сен", "Окт", "Ноя", "Дек"],
            "days": ["Воскресенье", "Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота"],
            "shortDays": ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
            "toolbar": {
                "exportToSVG": "Сохранить SVG",
                "exportToPNG": "Сохранить PNG",
                "menu": "Menu",
                "selection": "Выбор",
                "selectionZoom": "Выбор с увеличением",
                "zoomIn": "Увеличить",
                "zoomOut": "Уменьшить",
                "pan": "Перемещение",
                "reset": "Сбросить увеличение"
            }
        }
    }],
    defaultLocale: 'ru',
};

Apex.colors = [ '#FDCB00', '#7F7F7F', '#ED7D31', '#3F70C9', '#6FB143', '#bf9109', '#404040', '#7CAFDD', '#997300', '#DD2222', '#824999', '#22DD22', '#FF7FF8', '#AAAAAA', '#FF9999'  ];

